// extracted by mini-css-extract-plugin
export var deleteModal = "_rn-0";